import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=5fae9aa6&scoped=true&"
import script from "./heart.vue?vue&type=script&lang=js&"
export * from "./heart.vue?vue&type=script&lang=js&"
import style0 from "./heart.vue?vue&type=style&index=0&id=5fae9aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae9aa6",
  null
  
)

export default component.exports